import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './login.js'
import './plugins/element.js'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import 'jquery'
import * as custom from './common/filter.js'
// import Vuex from 'vuex'
// import Container from '@/components/Container';
// import iView from 'iview'    //引入ivew库
// import 'iview/dist/styles/iview.css'    // 使用 CSS

Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})
import VueAnimatedList from 'vue-animated-list'
import VueParticles from 'vue-particles'
Vue.use(VueParticles)
// Vue.use(iView)
Vue.prototype.$qs = qs
Vue.config.productionTip = false
//axios.defaults.baseURL = '/bc_cd_cdaee';
let env = process.env.NODE_ENV;
if(env == 'development')
{
	window.API_HOST = '/api';
}
else
{
   window.API_HOST = 'http://47.95.215.102:8081/hawkeye/';
  // window.API_HOST = 'http://192.168.1.254:8081/hawkeye_ll/';//设置你调用的接口域名和端口号 别忘了加http --春光
    //  window.API_HOST = 'http://192.168.1.112:8099/bc_hawkeye/';//--海洋/
    // window.API_HOST = 'http://192.168.1.116:8080/bc_hawkeye/'; // --乐乐
    // window.API_HOST = '/bc_creditcell';
		// window.DEEPSEA_HOST = 'http://182.150.6.137:8081/picture/';
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
Vue.use(VueAxios,axios,VueAnimatedList);
// Vue.use({
// 	VueAxios,
// 	axios,
// 	VueAnimatedList
// })
// Vue.use();

new Vue({
  router,
  store,
  VueAnimatedList,
  // components: { Container },
  render: h => h(App)
}).$mount('#app')
